import { Link } from "react-router-dom";

const ALL_LINKS = {
  directory: { to: "/directory", label: "Radio Directory", desc: "Live hip-hop, R&B, Jazz, Latin, and Rock stations streaming 24/7." },
  discover: { to: "/discover", label: "Discover Music", desc: "Featured tracks, blends, and new uploads from independent DJs." },
  artists: { to: "/artists", label: "Browse Artists", desc: "Indie artists from around the world on The NU Vibe Network." },
  network: { to: "/network", label: "Live Showcase", desc: "Premium stations streaming live video right now." },
  submit: { to: "/submit", label: "Submit Music", desc: "Get your tracks in front of our DJ pool and radio hosts." },
  news: { to: "/news", label: "Latest News", desc: "Artist spotlights, platform updates, and industry news." },
  advertise: { to: "/advertise", label: "Advertise", desc: "Reach thousands of monthly listeners with targeted radio ads." },
  affiliate: { to: "/affiliate", label: "Affiliate Program", desc: "Earn recurring commission for every station you refer." },
};

export default function RelatedLinks({ keys = ["directory", "discover", "artists", "network", "submit", "news"], heading = "Explore the Network", theme = "purple" }) {
  const accent = theme === "green" ? "text-green-400" : theme === "emerald" ? "text-emerald-400" : "text-purple-400";
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 py-16 border-t border-white/5 mt-12" data-testid="related-links">
      <h2 className="text-xl sm:text-2xl font-bold text-white mb-2">{heading}</h2>
      <p className="text-white/40 text-sm mb-8">Keep exploring DJsandMCMedia&trade; and The NU Vibe Network.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {keys.map((k) => {
          const item = ALL_LINKS[k];
          if (!item) return null;
          return (
            <Link
              key={k}
              to={item.to}
              className="group block rounded-xl border border-white/5 hover:border-white/15 bg-white/[0.02] hover:bg-white/[0.04] p-5 transition"
              data-testid={`related-${k}`}
            >
              <div className={`${accent} text-sm font-semibold mb-1 flex items-center gap-1.5`}>
                {item.label}
                <span className="transition-transform group-hover:translate-x-0.5">&rarr;</span>
              </div>
              <p className="text-white/50 text-xs leading-relaxed">{item.desc}</p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
